import ToastService from "./toastService";
import PaymentService from "./httpServices/payment.service";
import paymentServiceStripe from "./paymentStripe.service";
import { HTTP_CODES } from "../config/constants";

export default function UtilsService() {

  const { showSuccesToast, showErrorToast, showInfoToast } = ToastService();
  const { createCheckoutSession } = PaymentService();

  function downloadZip(blob, name) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = name + '.zip';
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
    showSuccesToast(`El archivo ZIP ${name}.zip ha sido descargado con éxito!`);
  }

  function downloadPDFblob(blob, name) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = name + '.pdf';
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
    showSuccesToast(`El pdf ${name} ha sido descargado con exito!`);
  }

  function downloadExcelblob(blob, name) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = name + '.xlsx';
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
    showSuccesToast(`El excel ${name} ha sido descargado con exito!`);
  }

  function getColorFromPercentage(percentage) {
    const r = Math.round(255 - (percentage / 100) * (255 - 82));
    const g = Math.round(77 + (percentage / 100) * (196 - 77));
    const b = Math.round(79 - (percentage / 100) * (79 - 26));
    return `rgb(${r}, ${g}, ${b})`;
  };

  /**
   * @function handlePayment
   * @description Handles the payment process and shows appropriate messages based on the response.
   * @param {string} email - The email address of the user.
   * @returns {Promise<void>}
   */
  async function paymentHelper(email) {
    try {
      const createSession = await createCheckoutSession(email);
      await paymentServiceStripe.redirectToCheckout({ sessionId: createSession.id });
    }
    catch (error) {
      const code = error.response?.status || HTTP_CODES.INTERNAL_SERVER_ERROR;

      switch (code) {
        case HTTP_CODES.CONFLICT:
          showInfoToast("Ya tienes una suscripción activa", "Refresca la página para ver los cambios");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          break;

        default:
          showErrorToast("Error inesperado, inténtelo más tarde");
          break;
      }
    }
  }

  return {
    downloadZip,
    downloadPDFblob,
    downloadExcelblob,
    getColorFromPercentage,
    paymentHelper,
  };
}
